import { render, staticRenderFns } from "./pricelist-item.vue?vue&type=template&id=6805b0ea&"
import script from "./pricelist-item.vue?vue&type=script&lang=js&"
export * from "./pricelist-item.vue?vue&type=script&lang=js&"
import style0 from "./pricelist-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports